import AsyncStorage from "@react-native-async-storage/async-storage";

export const getIndexOfDay = (day) => {

  switch (day.toLowerCase()) {
    case 'sunday': return 1;
    case 'monday': return 2;
    case 'tuesday': return 3;
    case 'wednesday': return 4;
    case 'thursday': return 5;
    case 'friday': return 6;
    case 'saturday': return 7;
  }
}


export const getPrefLangSchedule = async (props) => {

  let flag = false;
  let prefLangCode, schObj;
  let guestSelectedLang = await AsyncStorage.getItem('GuestPreferedLang');

  if (guestSelectedLang) {
    prefLangCode = guestSelectedLang;
  } else if (props.hotelLanguage.preferredLanguageCode) {
    prefLangCode = props.hotelLanguage.preferredLanguageCode;
  }

  if (props.hotelLanguage.languages) {
    props.hotelLanguage.languages.map((iterator) => {

      if (prefLangCode === iterator.languageCode) {

        if (props.webAppWidgetsInfo.schedules?.[prefLangCode] && props.webAppWidgetsInfo.schedules[prefLangCode].length) {
          flag = true;

          schObj = {
            schedules: props.webAppWidgetsInfo.schedules[prefLangCode],
            language: prefLangCode
          }
        } else if (props.webAppWidgetsInfo.defaultLayout?.[prefLangCode] && props.webAppWidgetsInfo.defaultLayout[prefLangCode].length) {
          flag = true
          schObj = {
            schedules: props.webAppWidgetsInfo.defaultLayout[prefLangCode],
            language: prefLangCode
          }
        }

        if (!flag) {
          schObj = {
            schedules: props.webAppWidgetsInfo.defaultLayout["en"],
            language: "en"
          }
        }
      }
    })
  }

  return schObj ? schObj : {}
}


export const getCurrentLayout = async (props, schObj) => {

  let flag = false
  let schStartT, schEndT, serverTime, schedule, schStartD, schEndD, currentDuration, durationId, layoutId;

  if (props.serverTimeDataObj && schObj.schedules) {
    
    let serverDay = getIndexOfDay(props?.serverTimeDataObj?.currentDay);

    let serverTimeObj = props.serverTimeDataObj.time
    serverTime = (serverTimeObj.hours * 60) + serverTimeObj.minutes + (serverDay * 1440);

    console.log("serverDay:", serverDay, "serverTime:", serverTime);
    
    schObj.schedules.map((iterator) => {

      schStartD = getIndexOfDay(iterator.startDay);
      schEndD = getIndexOfDay(iterator.endDay);
      
      let existBetweenDay;
      if (schStartD <= schEndD) {
        existBetweenDay = schStartD <= serverDay && schEndD >= serverDay
      } else {
        existBetweenDay = schStartD >= serverDay || schEndD >= serverDay
      }

      console.log("existBetweenDay:", existBetweenDay, serverTime);
      if(existBetweenDay) {
        schStartT = (parseInt(iterator.startTime.slice(0, 2)) * 60) + parseInt(iterator.startTime.slice(3, 5)) + (schStartD * 1440);
        schEndT = (parseInt(iterator.endTime.slice(0, 2)) * 60) + parseInt(iterator.endTime.slice(3, 5)) + (schEndD * 1440);

        console.log("schStartD:", schStartD, "schStartT:", schStartT, "schEndD:", schEndD ,"schEndT:", schEndT);

        if (schStartT <= serverTime && schEndT >= serverTime) {        
          flag = true;
          schedule = iterator;
        }
      }
    })

    if (!flag) {
      schedule = props.webAppWidgetsInfo.defaultLayout["en"][0];
    }

    props.webAppWidgetsInfo.durations.map((iterator) => {
      durationId = parseInt(iterator.durationId);
      layoutId = parseInt(schedule.layoutId);
      if (layoutId === durationId) {
        currentDuration = iterator
      }
    })

    await AsyncStorage.setItem('currentLayoutId', currentDuration.durationId)
    return currentDuration
  }
}

export const hashCode = (element) => {
  let hash = 0, l = element.length, i = 0;
  if (l > 0) {
    while (i < l) {
      hash = (hash << 5) - hash + element.charCodeAt(i++) | 0;
    }
  }
  return hash;
}